// Mesma regra do backend (src/helpers/DetectDeviceType.ts) — precisa ficar
// em sincronia com ela, senão a sessão única por tipo de dispositivo não
// bate: o backend decide em qual "slot" (desktop/mobile) o login entra, e
// aqui a gente só decide se ESTA aba deve se dar por derrubada quando chega
// um aviso de login em outro lugar.
const MOBILE_UA_REGEX = /Android|iPhone|iPod|iPad|Mobile|Windows Phone|BlackBerry|IEMobile|Opera Mini/i;

export function detectDeviceType() {
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  return MOBILE_UA_REGEX.test(ua) ? "mobile" : "desktop";
}
